module.exports = __webpack_public_path__ + "public/StoreIcon/edit.svg?d4486f01";